export const electricBlue = '#1fdcfe';
export const purple = '#8a04ed';
export const pink = '#ed41b7';
export const dark = '#231e27';
